import React, {FC} from "react";
import {InputNumber} from "antd";
import i18n from "../../services/i18n";

type RefundAmountFieldsProps = {
    /** Restbetrag, auf den sich Erstatten und Einbehalten beziehen. */
    remaining: number;
    refundAmount: number | null;
    onChange: (refundAmount: number | null) => void;
    size?: "small";
    autoFocus?: boolean;
};

const round2 = (value: number) => Math.round(value * 100) / 100;

/**
 * Gekoppelte Felder „Erstatten“ und „Einbehalten“: zusammen immer der Restbetrag.
 * Zustand ist nur der Erstattungsbetrag, der Einbehalt wird daraus abgeleitet. So können
 * die Felder nicht auseinanderlaufen. Wer in „Einbehalten“ tippt, setzt die Erstattung
 * auf Restbetrag minus Eingabe (Stornogebühr: 25 eintragen statt selbst rechnen).
 */
const RefundAmountFields: FC<RefundAmountFieldsProps> = ({remaining, refundAmount, onChange, size, autoFocus}) => {
    const retainedAmount = refundAmount == null ? null : round2(remaining - refundAmount);
    const tr = i18n.views.RefundPanel;
    const labelStyle = size === "small" ? {fontSize: 12, color: "rgba(0, 0, 0, 0.45)"} : {marginBottom: 4};

    return (
        <div style={{display: "flex", gap: size === "small" ? 8 : 12}}>
            <div style={{flex: 1, minWidth: 0}}>
                <div style={labelStyle}>{tr.fieldRefund()}</div>
                <InputNumber
                    autoFocus={autoFocus}
                    min={0.01}
                    max={remaining}
                    step={0.01}
                    precision={2}
                    size={size}
                    value={refundAmount as number | undefined}
                    onChange={(value) => onChange(value == null ? null : round2(Number(value)))}
                    style={{width: "100%"}}
                    data-testid="refund-amount-input"
                />
            </div>
            <div style={{flex: 1, minWidth: 0}}>
                <div style={labelStyle}>{tr.fieldRetained()}</div>
                <InputNumber
                    min={0}
                    max={remaining}
                    step={0.01}
                    precision={2}
                    size={size}
                    value={retainedAmount as number | undefined}
                    onChange={(value) => onChange(value == null ? null : round2(remaining - Number(value)))}
                    style={{width: "100%"}}
                    data-testid="refund-retained-input"
                />
            </div>
        </div>
    );
};

export default RefundAmountFields;
